const PropTypes = require('prop-types');
// @vendors
const React = require('react');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardError = require('components/commons/wizardError/wizardError');

//@constants
const { CARD_SIZE_MEDIUM } = require('constants/index');

const CardPinCvvRequestError = props => {
    const { immCard } = props;
    const title = formatText('cardPinRequest-errorTitle');
    const cardAlias = immCard.get('alias').get('current');
    const goBackButtonLabel = formatText('cardPinRequest-backToCard', [
        cardAlias
    ]).toUpperCase();
    const linkToMovements = `/myprofile/cards/${immCard.get('cardId')}/movements`;
    const goBackButton = {
        label: goBackButtonLabel,
        url: linkToMovements
    };

    return (
        <div className="col-xs-12 col-md-offset-2 col-md-8">
            <WizardError errorMessage={title} mainButton={goBackButton}>
                <section className="row">
                    <div className="col-xs-5">
                        <CommercialAds path="cards" type="cards" size={CARD_SIZE_MEDIUM} immCard={immCard} />
                    </div>
                    <div className="col-xs-7">
                        <FormattedText
                            value="cardPinRequest-errorMessage"
                        />
                    </div>
                </section>
            </WizardError>
        </div>
    )
};

CardPinCvvRequestError.propTypes = {
    immCard: PropTypes.object.isRequired
};

module.exports = CardPinCvvRequestError;